// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDBY1O-rGfQJtA84pxCddo02FBxQP1heTE",
  authDomain: "xtable-882df.firebaseapp.com",
  databaseURL: "https://xtable-882df-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "xtable-882df",
  storageBucket: "xtable-882df.appspot.com",
  messagingSenderId: "500004913038",
  appId: "1:500004913038:web:7ec1a8691e852032fd6edf",
  measurementId: "G-Y9XRSZPDHW"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const realtimeDatabase = getDatabase(app)

export {
  app,
  realtimeDatabase
}